// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__cIzpj","row":"ProcedureTreatmentSummary_row__2GOSU"};